module.exports = {
  isSold_ne: true,
};
